import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { RippleModule } from 'primeng/ripple';

@Component({
  selector: 'app-order-notify-modal',
  standalone: true,
  imports: [CommonModule, ButtonModule, RippleModule],
  templateUrl: './order-notify-modal.component.html',
  styleUrl: './order-notify-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderNotifyModalComponent {
  private readonly ref = inject(DynamicDialogRef);
  private readonly config = inject(DynamicDialogConfig);
  private readonly router = inject(Router);

  data: any = this.config.data.order;

  goToOrder(): void {
    this.ref.close('close');
    this.router.navigate([`/order/view-order/${this.data.orderId}`]);
  }
}
